export default __webpack_public_path__ + "static/media/12.d4ea511e.webp";